import { TAgeGroup, TGender } from '~/entities'

import { IVerifyV2Response } from '../verify/types'

export interface ISettings {
  skus?: string | number | (string | number)[] | null
  defaultGender?: TGender | Lowercase<TGender> | null
  defaultAgeGroup?: TAgeGroup | Lowercase<TAgeGroup> | null
  productValidated?: boolean | null
  verifyResponse?: IVerifyV2Response | null
  webview?: boolean | null
  appuser?: string | null
}

export enum EOrigin {
  Start = 'start',
  InjectButton = 'injectButton',
  FetchSkuWithUrlParameters = 'fetchSkuWithUrlParameters',
}

interface IStartNormalizedSettings {
  skus: string[]
  defaultGender: TGender | null
  defaultAgeGroup: TAgeGroup | null
  webview: boolean | null
  appuser: string | null
}

interface IInjectButtonNormalizedSettings {
  skus: string[]
  productValidated: boolean | null
  verifyResponse: IVerifyV2Response | null
}

interface IFecthSkuWithUrlNormalizedSettings {
  skus: string[]
  defaultGender: TGender | null
  webview: boolean | null
  appuser: string | null
}

export type TNormalizedSettings<T extends EOrigin> = T extends EOrigin.Start
  ? IStartNormalizedSettings
  : T extends EOrigin.InjectButton
  ? IInjectButtonNormalizedSettings
  : IFecthSkuWithUrlNormalizedSettings
